import { useEffect } from 'react';
import { FramePageContainer, Hidden, Loader, Stack, TrackingContext } from '@lingoda/ui';
import { Grid } from '@lingoda/ui/layout/GridNext';
import { useSelector, useToggleState } from '@lingoda/hooks';
import {
    SubscribeUnlockBanner,
    isSprintSubscriptionSelector,
    useSubscribeUnlockBanner,
} from '@lingoda/subscriptions';
import { useUserCreditsQuery } from '@lingoda/monolith-graphql';
import { extraCreditsNotAvailablePath, redirect } from '@lingoda/router';
import { BannersBlock, ClassCredits } from '../../components';
import { CreditsTypeInfoAlert, CreditsTypeInfoModal } from './CreditsTypeInfo';
import BuyCredits from './BuyCredits';

const ExtraCredits = () => {
    const [isInfoModalOpen, openInfoModal, closeInfoModal] = useToggleState(false);
    const { loading, data } = useUserCreditsQuery({ fetchPolicy: 'cache-and-network' });

    const isUnlockBannerVisible = useSubscribeUnlockBanner();
    const isCurrentSubscriptionSprint = useSelector(isSprintSubscriptionSelector);

    useEffect(() => {
        if (data?.studentCreditsInfo?.canBuyExtraCredits === false) {
            redirect(extraCreditsNotAvailablePath());
        }
    }, [data?.studentCreditsInfo?.canBuyExtraCredits]);

    if (loading) {
        return (
            <Loader minHeight={180} display="flex" alignItems="center" justifyContent="center" />
        );
    }

    return (
        <TrackingContext section="Buy Extra Credits">
            <FramePageContainer
                pt={{ xs: 2, sm: 3, md: 5 }}
                pb={{ xs: 2, sm: 3, md: 5 }}
                data-cy="Buy Extra Credits"
            >
                <Grid
                    container
                    spacing={{ xs: 2, md: 3, lg: 5 }}
                    direction={{ xs: 'column-reverse', md: 'row' }}
                >
                    <Grid md={7}>
                        <Stack spacing={2}>
                            <BuyCredits onCreditsInfoClick={openInfoModal} />
                            {isUnlockBannerVisible ? (
                                <SubscribeUnlockBanner withImage={false} />
                            ) : !isCurrentSubscriptionSprint ? (
                                <BannersBlock />
                            ) : null}
                        </Stack>
                    </Grid>
                    <Grid md={5}>
                        <Stack spacing={2}>
                            <ClassCredits />
                            <Hidden smDown>
                                <CreditsTypeInfoAlert />
                            </Hidden>
                        </Stack>
                    </Grid>
                </Grid>
            </FramePageContainer>
            <CreditsTypeInfoModal isOpen={isInfoModalOpen} onClose={closeInfoModal} />
        </TrackingContext>
    );
};

export default ExtraCredits;
